import PropTypes from 'prop-types'

import { getAssetLink } from '../../../helpers/get-asset-link'

const ContactItem = ({ data, onClick }) => {
  return (
    <div className={`contact-item`} onClick={() => onClick(null)}>
      <div className="contact-item-data">
        <div className="avatar-container">
          <img src={getAssetLink({ path: 'chitown-avatar/avatar', file: data.user.avatar })} />
        </div>
        <div className="user-name">
          {data.user.firstName} {data.user.lastName}
        </div>
      </div>
    </div>
  )
}

ContactItem.propTypes = {
  data: PropTypes.object,
  onClick: PropTypes.func,
}

export default ContactItem
